/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PermissionCategory } from '../models/PermissionCategory';
import { PermissionType } from '../models/PermissionType';

export class Permission {
  'permissionType': PermissionType;
  /**
  * The description of the permission
  */
  'description': string;
  /**
  * When true, this permission may be granted under an access condition (using accessConditionId on a PermissionGrant). When false, any PermissionGrant for this permission must NOT specify accessConditionId.
  */
  'allowConditions': boolean;
  'category': PermissionCategory;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "permissionType",
      "baseName": "permissionType",
      "type": "PermissionType",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "allowConditions",
      "baseName": "allowConditions",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "category",
      "baseName": "category",
      "type": "PermissionCategory",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Permission.attributeTypeMap;
  }

  public constructor() {
  }
}



